export default "__VITE_ASSET__BdvP3AVC__"